"use client"
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import "./style.css"
import Sticker from '../sticker/page'
import formatMsg from '../../util/formatMsg'
import { TableWrapper } from '../wrapperComponents/page'
import { Col, Input, Row, Select, Spin, Tag } from 'antd'
import Helper from '../../util/helper'
import { SearchOutlined } from '@ant-design/icons';
import { FilterDateSelector, FiltersBottomSheet, MobileFilterButton, multicenterActions, packageActions, permissions, timeutil } from 'sharedresources'
import { useDispatch } from 'react-redux'
import TransactionMobileCard from './TransactionMobileCard'
const { getAllCentersList } = multicenterActions;
const { getAllPackageNames, getPackageListDropdown } = packageActions;
const page = (props) => {

    const dispatch = useDispatch();
    const { accountReducer, multicenterReducer, packageReducer, invoiceReducer, firebase } = Helper.getSelectorState(["accountReducer", "multicenterReducer", "packageReducer", "invoiceReducer"]);

    const { allCentersList } = multicenterReducer;
    const permittedCentersList = useMemo(() => {
        return (allCentersList || []).filter((center) =>
            permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.PAYMENT_VIEW, [center.id])
        );
    }, [allCentersList, firebase]);
    const { packageNames, packageList } = packageReducer;

    const { transactionLists } = props;

    const [transactionList, setTransactionList] = useState([]);
    const [totalTransaction, setTotalTransaction] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [failedTransaction, setFailedTransaction] = useState({
        amount: 0,
        count: 0
    })

    const currency = Helper.getCurrency(firebase);

    const [search, setSearch] = useState(undefined);
    const [packageFilter, setPackageFilter] = useState(undefined);
    const [centerFilter, setCenterFilter] = useState(undefined);
    const [accountFilter, setAccountFilter] = useState(undefined);
    const [statusFilter, setStatusFilter] = useState(undefined);

    const [accountsMap, setAccountsMap] = useState(new Map());
    const [centersMap, setCentersMap] = useState(new Map());
    const [packagesMap, setPackagesMap] = useState(new Map());

    const [showFiltersBottomSheet, setShowFiltersBottomSheet] = useState(false);
    const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);
    const [txPageNo, setTxPageNo] = useState(1);
    const [txPageSize, setTxPageSize] = useState(10);

    const handleAccountFilterChange = useCallback((acountFilterVal) => {

        const isAllSelected: boolean = acountFilterVal?.some((val) => val === 'all accounts') || false;

        if (Helper.getAccountList(firebase) && isAllSelected) {
            acountFilterVal = Helper.getAccountList(firebase).map((item) => item.id);
        }

        let stringifiedData = acountFilterVal ? JSON.stringify(acountFilterVal) : '';

        setAccountFilter(acountFilterVal);
        Helper.setUrlParam("transactAccountFilter", stringifiedData);

    }, [setAccountFilter, accountReducer.accountList]);

    const handleCenterFilterChange = useCallback((centerFilterVal) => {

        const isAllSelected: boolean = centerFilterVal?.some((val) => val === 'all centers') || false;

        if (permittedCentersList && isAllSelected) {
            centerFilterVal = permittedCentersList.map((item) => item.id);
        }

        let stringifiedData = centerFilterVal ? JSON.stringify(centerFilterVal) : '';

        setCenterFilter(centerFilterVal);
        Helper.setUrlParam('transactCenterFilter', stringifiedData);

    }, [setCenterFilter, permittedCentersList]);

    const handlePackageFilterChange = useCallback((packageFilterVal) => {

        const isAllSelected: boolean = packageFilterVal?.some((val) => val === 'all packages') || false;
        const pkgNames = isTeacherLoggedIn ? packageNames : packageList;
        if (pkgNames && isAllSelected) {
            packageFilterVal = pkgNames.map((item) => item.id);
        }

        let stringifiedData = packageFilterVal ? JSON.stringify(packageFilterVal) : '';

        setPackageFilter(packageFilterVal);
        Helper.setUrlParam('transactPackageFilter', stringifiedData);

    }, [setPackageFilter, packageNames, packageList]);

    const handleStatusFilterChange = useCallback((statusFilterVal) => {

        const isAllSelected: boolean = statusFilterVal?.some((val) => val === 'all status') || false;

        if (transactionStatusesList.current && isAllSelected) {
            statusFilterVal = transactionStatusesList.current.map((item) => item);
        }

        let stringifiedData = statusFilterVal ? JSON.stringify(statusFilterVal) : '';

        setStatusFilter(statusFilterVal);
        Helper.setUrlParam('transactStatusFilter', stringifiedData);

    }, [setStatusFilter]);


    const handleSearchChange = useCallback((val) => {
        setSearch(val);
        Helper.setUrlParam('transactSearch', val ? val : '');
    }, [setSearch]);

    const handlePageChange = useCallback((newPageNo, newPageSize) => {
        setTxPageNo(newPageNo);
        setTxPageSize(newPageSize);
        Helper.setUrlParam('txPageNo', newPageNo ? newPageNo : 1);
        Helper.setUrlParam('txPageSize', newPageSize ? newPageSize : 10);
    }, [setTxPageNo, setTxPageSize]);


    useEffect(() => {
        if (Helper.getAccountList(firebase)) {
            const newAccountsMap = new Map();
            Helper.getAccountList(firebase).forEach((item) => newAccountsMap.set(item.id, item));
            setAccountsMap(newAccountsMap);
        }
    }, [accountReducer.accountList]);

    useEffect(() => {
        if (permittedCentersList) {
            const newCentersMap = new Map();
            permittedCentersList.forEach((item) => newCentersMap.set(item.id, item));
            setCentersMap(newCentersMap);
        }
    }, [permittedCentersList]);

    useEffect(() => {
        const packages = isTeacherLoggedIn ? packageNames : packageList;
        if (packages) {
            const newPackagesMap = new Map();
            packages.forEach((item) => newPackagesMap.set(item.id, item));
            setPackagesMap(newPackagesMap);
        }
    }, [packageNames, packageList]);


    const transactionStatusesList = useRef([
        "successful",
        "failed"
    ]);


    const isTeacherLoggedIn = Helper.getLoggedInUserType(firebase).toLowerCase() === "teacher";

    const renderSearchBar = isView(['userPaymentsView', 'adminPaymentsView', 'adminPackageDetail', 'adminAccountDetail']);
    const renderAccountFilter = isTeacherLoggedIn && isView(['adminPaymentsView', 'adminPackageDetail']);
    const renderCenterFilter = isTeacherLoggedIn && isView(['adminPaymentsView', 'adminPackageDetail', 'adminAccountDetail']);
    const renderPackageFilter = isView(['userPaymentsView', 'adminPaymentsView', 'adminAccountDetail']);
    const renderStatusFilter = isView(['userPaymentsView', 'adminPaymentsView', 'adminPackageDetail', 'adminAccountDetail']);


    const [filterNameToFilterMetaDataObjMap, setFilterNameToFilterMetaDataObjMap] = useState(
        getFilterNameToFilterMetaDataObjMapForView()
    );


    function getFilterNameToFilterMetaDataObjMapForView() {

        const newFilterNameToFilterMetaDataObjMap = new Map();

        if (renderAccountFilter) {
            newFilterNameToFilterMetaDataObjMap.set('filterLabel.accounts', {
                optionsArr: Helper.getAccountList(firebase) || [],
                selectedVal: accountFilter,
                setSelectedVal: handleAccountFilterChange,
                showAllOption: true,
                filterType: 'multiSelect'
            });
        }
        if (renderCenterFilter) {
            newFilterNameToFilterMetaDataObjMap.set('filterLabel.centers', {
                optionsArr: permittedCentersList || [],
                selectedVal: centerFilter,
                setSelectedVal: handleCenterFilterChange,
                showAllOption: true,
                filterType: 'multiSelect'
            });
        }
        if (renderPackageFilter) {
            newFilterNameToFilterMetaDataObjMap.set('filterLabel.packages', {
                optionsArr: isTeacherLoggedIn ? packageNames || [] : packageList || [],
                selectedVal: packageFilter,
                setSelectedVal: handlePackageFilterChange,
                showAllOption: true,
                filterType: 'multiSelect'
            });
        }
        if (renderStatusFilter) {
            newFilterNameToFilterMetaDataObjMap.set('filterLabel.status', {
                optionsArr: transactionStatusesList.current || [],
                selectedVal: statusFilter,
                setSelectedVal: handleStatusFilterChange,
                showAllOption: true,
                filterType: 'multiSelect'
            });
        }

        return newFilterNameToFilterMetaDataObjMap;
    }

    useEffect(() => {
        setFilterNameToFilterMetaDataObjMap(
            getFilterNameToFilterMetaDataObjMapForView()
        );
    }, [accountReducer.accountList, accountFilter, handleAccountFilterChange, permittedCentersList, centerFilter, handleCenterFilterChange, packageNames, packageFilter, handlePackageFilterChange, statusFilter, handleStatusFilterChange, packageList]);

    useEffect(() => {
        getTotalTransaction();
        getTotalRevenue();
        getTotalFailedTransaction();
    }, [transactionLists])

    useEffect(() => {
        filterList();
    }, [transactionLists, search, packageFilter, centerFilter, accountFilter, statusFilter]);

    const userIdToObjMap = useRef(new Map());
    const usersList = Helper.getUserList(firebase);

    const newUserMap = new Map();
    usersList.forEach((userObj) => {
        newUserMap.set(userObj.id, userObj);
    });

    userIdToObjMap.current = newUserMap;

    const [accountIdToObjMap, setAccountIdToObjMap] = useState(new Map());
    const [packageIdToObjMap, setPackageIdToObjMap] = useState(new Map());

    useEffect(() => {
        const newAccountMap = new Map();
        Helper.getAccountList(firebase)?.forEach((accountObj) => {
            newAccountMap.set(accountObj.id, accountObj);
        });
        setAccountIdToObjMap(newAccountMap);
    }, [accountReducer.accountList]);

    useEffect(() => {
        const newPackageMap = new Map();
        const packages = isTeacherLoggedIn ? packageNames : packageList;
        packages.forEach((packageObj) => {
            newPackageMap.set(packageObj.id, packageObj);
        });
        setPackageIdToObjMap(newPackageMap);
    }, [packageNames, packageList]);


    const getFilterUrlParam = () => {

        let search = Helper.getUrlParam("transactSearch");
        search = Helper.checkUrlParam(search, undefined);
        if (search) setSearch(search);

        let accountFilterJSONString = Helper.getUrlParam("transactAccountFilter");
        let accountFilterParsedJSON = accountFilterJSONString ? JSON.parse(accountFilterJSONString) : undefined;
        if (accountFilterParsedJSON) setAccountFilter(accountFilterParsedJSON);

        let centerFilterJSONString = Helper.getUrlParam("transactCenterFilter");
        let centerFilterParsedJSON = centerFilterJSONString ? JSON.parse(centerFilterJSONString) : undefined;
        if (centerFilterParsedJSON) setCenterFilter(centerFilterParsedJSON);

        let packageFilterJSONString = Helper.getUrlParam("transactPackageFilter");
        let packageFilterParsedJSON = packageFilterJSONString ? JSON.parse(packageFilterJSONString) : undefined;
        if (packageFilterParsedJSON) setPackageFilter(packageFilterParsedJSON);

        let statusFilterJSONString = Helper.getUrlParam("transactStatusFilter");
        let statusFilterParsedJSON = statusFilterJSONString ? JSON.parse(statusFilterJSONString) : undefined;
        if (statusFilterParsedJSON) setStatusFilter(statusFilterParsedJSON);

        let txPageNo: any = Helper.getUrlParam("txPageNo");
        txPageNo = Helper.checkUrlParam(txPageNo, 1, "number");
        if (txPageNo) setTxPageNo(txPageNo);

        let txPageSize: any = Helper.getUrlParam("txPageSize");
        txPageSize = Helper.checkUrlParam(txPageSize, 10, "number");
        if (txPageSize) setTxPageSize(txPageSize);
    }


    useEffect(() => {

        getFilterUrlParam();

        if (isTeacherLoggedIn) {
            dispatch(getAllCentersList({ firebase }));
            dispatch(getAllPackageNames({ firebase }));
        } else {
            dispatch(getPackageListDropdown({ firebase }));
        }

    }, [])

    const getTotalTransaction = () => {
        setTotalTransaction(transactionLists.filter((transaction) => permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.PAYMENT_VIEW, transaction.centerId ? [transaction.centerId] : [])).length);
    };

    const getTotalRevenue = () => {
        const revenue = (Array.isArray(transactionLists) ? transactionLists : []).filter((transaction) => permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.PAYMENT_VIEW, transaction.centerId ? [transaction.centerId] : [])).reduce((sum, transaction) => {
            const amount = Number(transaction?.amount);
            return sum + (isNaN(amount) ? 0 : amount);
        }, 0);

        setTotalRevenue(revenue);
    };

    const getTotalFailedTransaction = () => {
        const summary = (Array.isArray(transactionLists) ? transactionLists : []).reduce(
            (acc, transaction) => {
                if (transaction?.status === "failed") {
                    const amount = Number(transaction.amount);
                    if (!isNaN(amount)) {
                        acc.amount += amount;
                        acc.count += 1;
                    }
                }
                return acc;
            },
            { amount: 0, count: 0 }
        );

        setFailedTransaction(summary);
    };

    const filterList = () => {

        let selectedAccountsSet = new Set();
        if (accountFilter?.length) selectedAccountsSet = new Set(accountFilter);

        let selectedCentersSet = new Set();
        if (centerFilter?.length) selectedCentersSet = new Set(centerFilter);

        let selectedPackagesSet = new Set();
        if (packageFilter?.length) selectedPackagesSet = new Set(packageFilter);

        let selectedStatusesSet = new Set();
        if (statusFilter?.length) {
            statusFilter.forEach((status) => {
                selectedStatusesSet.add(status.toLowerCase());
            });
        }

        let filteredData = (Array.isArray(transactionLists) ? transactionLists : []).filter((transaction) => {

            const matchedUser = userIdToObjMap.current && userIdToObjMap.current.get(transaction.profileId);
            const matchedAccount = accountIdToObjMap && accountIdToObjMap.get(transaction.accountId);

            const searchMatch = !search || search.trim() == "" || (transaction.transactionId && transaction.transactionId.toLowerCase().includes(search.toLowerCase())) || (transaction.invoiceNumber && transaction.invoiceNumber.toLowerCase().includes(search.toLowerCase())) || (matchedAccount?.name && matchedAccount.name.toLowerCase().includes(search.toLowerCase())) || (matchedUser?.name && matchedUser.name.toLowerCase().includes(search.toLowerCase())) || (transaction.packageName && transaction.packageName.toLowerCase().includes(search.toLowerCase()));

            const packageMatch = !packageFilter?.length || selectedPackagesSet.has(transaction.packageId);

            const centerMatch = !centerFilter?.length || selectedCentersSet.has(transaction.centerId);

            const accountMatch = !accountFilter?.length || (transaction.accountId && selectedAccountsSet.has(transaction.accountId));

            const statusMatch = !statusFilter?.length || selectedStatusesSet.has(transaction.status.toLowerCase());

            const hasPermission = permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.PAYMENT_VIEW, transaction.centerId ? [transaction.centerId] : []);

            return searchMatch && packageMatch && centerMatch && accountMatch && statusMatch && hasPermission;
        });

        setTransactionList(filteredData);
    };



    let columns = [
        {
            key: 'transactionId',
            dataIndex: 'transactionId',
            title: <div className='tsx-table-item-gap'>
                <div className="tsx-main-heading">{formatMsg("transactionId")}</div>
                <div className="tsx-sub-heading">{formatMsg("bookingId")}</div>
            </div>,
            sorter: (a, b) => Helper.sortStringValue(a, b, "transactionId"),
            render: (text, record) => {
                return (
                    <div className='tsx-table-item-gap'>
                        <div className="tsx-main-body">{record.transactionId || " - "}</div>
                        <div className="tsx-sub-body">{record.bookingNumber || " - "}</div>
                    </div>
                )
            }
        },
        ...(isTeacherLoggedIn ? [{
            key: 'customerAccounts',
            dataIndex: 'accountId',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("customerAccounts")}</div>
            </div>,
            sorter: (a, b) => {
                const accountA = accountIdToObjMap && accountIdToObjMap.get(a.accountId)?.name || "";
                const accountB = accountIdToObjMap && accountIdToObjMap.get(b.accountId)?.name || "";
                return accountA.localeCompare(accountB);
            },
            render: (text, record) => {
                const matchedUser = userIdToObjMap.current && userIdToObjMap.current.get(record.profileId);
                const matchedAccount = accountIdToObjMap && accountIdToObjMap.get(record.accountId);
                return (
                    <div>
                        {matchedAccount?.name && <div className="inv-main-body" style={{ marginBottom: "10px" }}>{matchedAccount.name}</div>}
                        {matchedUser?.name && (
                            <Tag color={"#DDDDDD"} style={{ borderRadius: "12px", color: "black" }}>
                                {matchedUser?.name}
                            </Tag>
                        )}
                    </div>
                )
            }
        }] : []),
        {
            key: 'invoiceId',
            dataIndex: 'invoiceNumber',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("invoice.invoiceNumber")}</div>
            </div>,
            sorter: (a, b) => Helper.sortStringValue(a, b, "invoiceNumber"),
            render: (text, record) => {
                return (
                    <div className="inv-main-body">
                        {record.invoiceNumber || " - "}
                    </div>
                )
            }
        },
        {
            key: 'packageName',
            dataIndex: 'packageId',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("invoice.packageName")}</div>
            </div>,
            sorter: (a, b) => {
                const packageA = packageIdToObjMap && packageIdToObjMap.get(a.packageId)?.name || "";
                const packageB = packageIdToObjMap && packageIdToObjMap.get(b.packageId)?.name || "";
                return packageA.localeCompare(packageB);
            },
            render: (text, record) => {
                {
                    const matchedPackage = packageIdToObjMap && packageIdToObjMap.get(record.packageId);
                    return (
                        matchedPackage?.name && <div className="inv-main-body">
                            {matchedPackage?.name}
                        </div>
                    )
                }
            }
        },
        {
            key: 'paymentMethod',
            dataIndex: 'paymentMode',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("paymentMethod")}</div>
            </div>,
            sorter: (a, b) => Helper.sortStringValue(a, b, "paymentMode"),
            render: (text, record) => (
                <div className="inv-main-body">
                    <div>{record.paymentMode}</div>
                </div>
            )
        },
        {
            key: 'date',
            dataIndex: 'date',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("date")}</div>
            </div>,
            sorter: (a, b) => Helper.sortIntegerValue(a, b, "date"),
            render: (text, record) => {
                return (
                    <div className="inv-main-body">
                        {timeutil.getInstance(record.date).format("DD MMM YYYY")}
                    </div>
                )
            }
        },
        {
            key: 'amount',
            dataIndex: 'amount',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("amount")}</div>
            </div>,
            sorter: (a, b) => Helper.sortIntegerValue(a, b, "amount"),
            render: (text, record) => {
                return (
                    <div>
                        <div className="inv-main-body">{formatMsg('paid')}: {currency}{record.amount}</div>
                    </div>
                )
            }

        },
        {
            key: 'status',
            dataIndex: 'status',
            title: <div>
                <div className="tsx-main-heading">{formatMsg("status")}</div>
            </div>,
            render: (text, record) => {

                return (
                    <div>
                        <div className="inv-main-body">{Helper.getAmountStatusTag(text)}</div>
                    </div>

                )
            }
        },
    ]

    function isView(inputArr) {
        return inputArr.some((viewVal) => viewVal === props.view);
    }

    const isLoading = accountReducer.isLoading || multicenterReducer.isLoading || packageReducer.isLoading || invoiceReducer.isLoading;

    return (
        <>
            <div>
                <Row align={"middle"} justify={"center"} style={{ marginBottom: 24 }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div className="transaction-container">

                            {isTeacherLoggedIn &&
                                isView(['adminPaymentsView', 'adminPackageDetail']) &&
                                <div className="stickers-container">
                                    <Sticker
                                        name={"TOTAL_TRANSACTION"}
                                        style={styles.stickerStyle}
                                        title={
                                            <div style={{ display: "flex", flexDirection: "column" }}>

                                                <div className="sticker-left">
                                                    <img src="/images/oustanding.png" className="sticker-icon" />
                                                    <div className="sticker-title">{formatMsg("totalTransaction")}</div>
                                                </div>
                                                <div className="sticker-value">{totalTransaction}</div>
                                            </div>

                                        }
                                        onClick={() => {
                                            return null;
                                        }}
                                    />

                                    <Sticker
                                        name={"TOTAL_REVENUE"}
                                        style={styles.stickerStyle}
                                        title={
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className="sticker-left">
                                                    <img src="/images/paid.png" className="sticker-icon" />
                                                    <div className="sticker-title">{formatMsg("totalRevenue")}</div>
                                                </div>
                                                <div className="sticker-value">{currency} {Helper.roundNumberToTwo(totalRevenue)}</div>

                                            </div>
                                        }
                                        onClick={() => {
                                            return null;
                                        }}

                                    />

                                    <Sticker
                                        name={"FAILED_TRANSACTION"}
                                        style={{ ...styles.stickerStyle, justifyContent: "space-between" }}
                                        title={
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <div className="sticker-left">
                                                    <img src="/images/failedTransaction.png" className="sticker-icon" />
                                                    <div className="sticker-title">{formatMsg("failedTransaction")}</div>
                                                </div>
                                                <div className="sticker-value">{currency} {Helper.roundNumberToTwo(failedTransaction.amount)}</div>

                                            </div>
                                        }
                                        subTitle={
                                            <div className="sticker-badge overdue">{failedTransaction.count}</div>
                                        }
                                        onClick={() => {
                                            return null;
                                        }}
                                    />
                                </div>}

                            <Row
                                justify="space-between"
                                typeof="flex"
                                gutter={[15, 12]}
                                className='laptop-payment-filters-row'
                            >
                                {
                                    renderSearchBar &&
                                    <Col xs={24} sm={24} md={24} lg={24} xl={8} xxl={8}>
                                        <Row typeof="flex" gutter={[15, 12]}>
                                            <Col
                                                xxl={20}
                                                xl={20}
                                                lg={12}
                                                md={12}
                                                sm={24}
                                                xs={24}
                                            >
                                                <Input
                                                    placeholder={formatMsg("transaction.search")}
                                                    style={{ width: "100%" }}
                                                    value={search}
                                                    onChange={(e) => handleSearchChange(e.target.value)}
                                                    suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                />
                                            </Col>

                                        </Row>
                                    </Col>
                                }
                                <Col xs={24} sm={24} md={24} lg={24} xl={16} xxl={16}>
                                    <Row typeof="flex" justify="end" gutter={[15, 12]}>
                                        {
                                            isView(['adminPackageDetail', "adminAccountDetail"]) &&
                                            <Col
                                                xs={24} sm={24} md={12} lg={12} xl={6} xxl={6}
                                            >
                                                <FilterDateSelector
                                                    dateRange={props.dateRange}
                                                    setDateRange={props.setDateRange}
                                                />
                                            </Col>
                                        }
                                        {
                                            renderAccountFilter &&
                                            <Col
                                                xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} style={styles.colStyle}
                                            >
                                                <Select
                                                    mode='multiple'
                                                    onChange={handleAccountFilterChange}
                                                    maxTagCount={0}
                                                    maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('account', accountFilter, accountsMap)}
                                                    placeholder={formatMsg("placeholder.selectCustomerAccounts")}
                                                    style={{ width: "100%" }}
                                                    value={accountFilter}
                                                    allowClear
                                                    popupMatchSelectWidth={false}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                                                >
                                                    <Select.Option
                                                        key={'all accounts'}
                                                        value={'all accounts'}
                                                    >
                                                        {formatMsg('caps.allAccounts')}
                                                    </Select.Option>
                                                    {Helper.getAccountList(firebase)?.map((account, index) => (
                                                        <Select.Option key={account.id} value={account.id}>
                                                            {account.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Col>
                                        }
                                        {
                                            renderCenterFilter &&
                                            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} style={styles.colStyle}>
                                                <Select
                                                    mode='multiple'
                                                    onChange={handleCenterFilterChange}
                                                    maxTagCount={0}
                                                    maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('center', centerFilter, centersMap)}
                                                    placeholder={formatMsg("placeholder.selectCenters")}
                                                    style={{ width: "100%" }}
                                                    value={centerFilter}
                                                    allowClear
                                                    popupMatchSelectWidth={false}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                                                >
                                                    <Select.Option
                                                        key={"all"}
                                                        value={"all centers"}
                                                    >
                                                        {formatMsg("allCenters")}
                                                    </Select.Option>
                                                    {permittedCentersList.map((center, index) => (
                                                        <Select.Option key={center.id} value={center.id}>
                                                            {center.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Col>
                                        }
                                        {
                                            renderPackageFilter &&
                                            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} style={styles.colStyle}>
                                                <Select
                                                    mode='multiple'
                                                    onChange={handlePackageFilterChange}
                                                    maxTagCount={0}
                                                    maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('package', packageFilter, packagesMap)}
                                                    placeholder={formatMsg("placeholder.selectPackages")}
                                                    style={{ width: "100%" }}
                                                    value={packageFilter}
                                                    allowClear
                                                    popupMatchSelectWidth={false}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                                                >
                                                    <Select.Option
                                                        key={"all"}
                                                        value={"all packages"}
                                                    >
                                                        {formatMsg("caps.allPackages")}
                                                    </Select.Option>
                                                    {(isTeacherLoggedIn ? packageNames : packageList)?.map((item, index) => (
                                                        permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.PAYMENT_VIEW, item.centerIds) &&
                                                        <Select.Option key={item.id} value={item.id}>
                                                            {item.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Col>
                                        }

                                        {
                                            renderStatusFilter &&
                                            <Col xs={24} sm={24} md={12} lg={12} xl={6} xxl={6} style={styles.colStyle}>
                                                <Select
                                                    mode='multiple'
                                                    onChange={handleStatusFilterChange}
                                                    maxTagCount={0}
                                                    maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('status', statusFilter)}
                                                    placeholder={formatMsg("selectStatus")}
                                                    style={{ width: "100%" }}
                                                    value={statusFilter}
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
                                                >
                                                    {
                                                        ["all status", ...transactionStatusesList.current].map((status) => {
                                                            return (
                                                                <Select.Option
                                                                    value={status}
                                                                >
                                                                    {formatMsg(status || '-')}
                                                                </Select.Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                            </Row>

                            {
                                isView(['userPaymentsView', 'adminPaymentsView', 'adminPackageDetail', 'adminAccountDetail']) &&
                                <div className='mobile-payment-filters-row'>
                                    <div className='mob-payments-search-filter-container'>
                                        <Input
                                            width={"100%"}
                                            value={search}
                                            onChange={e => handleSearchChange(e.target.value)}
                                            placeholder={formatMsg("search")}
                                            suffix={<SearchOutlined />}
                                        />
                                    </div>

                                    <div className='mob-date-range-selector-row'>
                                        {
                                            (props.dateRange && props.setDateRange) &&
                                            <div className='mobile-date-range-filter'>
                                                <FilterDateSelector
                                                    dateRange={props.dateRange}
                                                    setDateRange={props.setDateRange}
                                                />
                                            </div>
                                        }

                                        <MobileFilterButton
                                            setShowFiltersBottomSheet={setShowFiltersBottomSheet}
                                            appliedFiltersCount={appliedFiltersCount}
                                            btnContCss={'transact-mob-filter-btn'}
                                        />
                                    </div>
                                </div>
                            }

                            <div className='transactions-table-view'>
                                <TableWrapper
                                    columns={columns}
                                    dataSource={transactionList}
                                    pagination={{
                                        current: txPageNo,
                                        pageSize: txPageSize,
                                        onChange: handlePageChange,
                                        showSizeChanger: true,
                                        hideOnSinglePage: false
                                    }}
                                    loading={isLoading}
                                />
                            </div>

                            <Spin spinning={isLoading}>
                                <div className='transactions-list-view'>
                                    {transactionList.map((transactionObj) => (
                                        <TransactionMobileCard
                                            transactionObj={transactionObj}
                                            firebase={firebase}
                                            packageIdToObjMap={packageIdToObjMap}
                                        />
                                    ))}
                                </div>
                            </Spin>
                        </div>
                    </Col>
                </Row>
            </div>
            <FiltersBottomSheet
                firebase={firebase}
                filterNameToFilterMetaDataObjMap={filterNameToFilterMetaDataObjMap}
                showFiltersBottomSheet={showFiltersBottomSheet}
                setShowFiltersBottomSheet={setShowFiltersBottomSheet}
                setAppliedFiltersCount={setAppliedFiltersCount}
            />
        </>
    )
}

export default page
const styles = {
    colStyle: {
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: "nowrap"
    },
    stickerStyle: {
        minWidth: "320px",
        maxWidth: "400px",
        flex: "1 1 fit-content",
        boxShadow: "0px 4px 25px 0px #00000026",
        // border: "1px solid #D0D0D0",
        borderRadius: "12px"
    }
}
